module.exports = __webpack_public_path__ + "static/media/2.10ea62e0.webp";